export default [
  {
    name: "starTexture",
    type: "texture",
    path: "textures/5.png",
  },
  // {
  //   name: "frame1",
  //   type: "texture",
  //   path: "sample-callouts/frame1.png",
  // },
  {
    name: "frame2",
    type: "texture",
    path: "sample-callouts/frame2.png",
  },
  {
    name: "frame3",
    type: "texture",
    path: "sample-callouts/frame3.png",
  },
  {
    name: "frame4",
    type: "texture",
    path: "sample-callouts/frame4.png",
  },
  {
    name: "frame5",
    type: "texture",
    path: "sample-callouts/frame5.png",
  },
  {
    name: "frame6",
    type: "texture",
    path: "sample-callouts/frame6.png",
  },
  {
    name: "frame7",
    type: "texture",
    path: "sample-callouts/frame7.png",
  },
  // {
  //   name: "frame8",
  //   type: "texture",
  //   path: "sample-callouts/frame8.png",
  // },
];
